import type { GameModule } from '@arcraz/arcadia-types';
import astrofall from './astrofall/index.js';
import cargoClimb from './cargo-climb/index.js';
import cityHop from './city-hop/index.js';
import cubeJump from './cube-jump/index.js';
import defenseGrid from './defense-grid/index.js';
import demo from './demo/index.js';
import interceptor from './interceptor/index.js';
import jadeTunnel from './jade-tunnel/index.js';
import mazePatrol from './maze-patrol/index.js';
import neonOverpass from './neon-overpass/index.js';
import pirateFleet from './pirate-fleet/index.js';
import sectorSeven from './sector-seven/index.js';
import stardust from './stardust/index.js';
import trenchRun from './trench-run/index.js';

/**
 * The cartridge catalog. Each entry is a `GameModule` per
 * `@arcraz/arcadia-types`. The cabinet's selector (sc-2818) reads this
 * list to render the vertical tile stack.
 *
 * Order is curated, not alphabetical — it's the marquee lineup.
 * DEMO will be removed once enough real cartridges exist; keeping it for
 * now as the cabinet's "smallest valid GameModule" sanity check.
 */
export const CARTRIDGES: readonly GameModule[] = [
  neonOverpass,
  astrofall,
  cargoClimb,
  jadeTunnel,
  cubeJump,
  defenseGrid,
  mazePatrol,
  trenchRun,
  sectorSeven,
  interceptor,
  stardust,
  cityHop,
  pirateFleet,
  demo,
];
